<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="List Chevrons Down Up" class="d-icon d-icon--list-chevrons-down-up" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 9a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h4Zm3.225-1.418a.5.5 0 0 1 .629.064l1.5 1.5a.5.5 0 1 1-.707.708L9 8.707 7.854 9.854a.5.5 0 1 1-.708-.708l1.5-1.5.079-.064ZM5.5 5.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h4Zm4.646-3.354a.5.5 0 1 1 .707.708l-1.5 1.5a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 1 1 .708-.708L9 3.293l1.146-1.147ZM5.5 2a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h4Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconListChevronsDownUp',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
